import { render } from "./WarehouseServicePage.vue?vue&type=template&id=1fdf82aa&scoped=true"
import script from "./WarehouseServicePage.vue?vue&type=script&lang=js"
export * from "./WarehouseServicePage.vue?vue&type=script&lang=js"

import "./WarehouseServicePage.vue?vue&type=style&index=0&id=1fdf82aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdf82aa"]])

export default __exports__